export class TextProps {
  constructor(props = {}) {
    this.fontFamily = props.fontFamily;
    this.fontSize = props.fontSize;
    this.fontUnit = props.fontUnit;
    this.fontColor = props.fontColor;
    this.fontWeight = props.fontWeight;
    this.textAlign = props.textAlign;
    this.isLetterSpacingEnabled = props.isLetterSpacingEnabled;
    this.whiteSpace = props.whiteSpace;
    this.outlineColor = props.outlineColor;
    this.outlineWidth = props.outlineWidth;
    this.lineHeight = props.lineHeight;
  }

  getStyles() {
    const letterSpacing = this.isLetterSpacingEnabled ? '6px' : 'normal';
    const styles = {
      fontFamily: this.fontFamily,
      fontSize: `${this.fontSize}${this.fontUnit}`,
      color: this.fontColor,
      fontWeight: this.fontWeight,
      textAlign: this.textAlign,
      lineHeight: `${this.lineHeight}px`,
      '-webkit-text-stroke-color': this.outlineColor,
      '-webkit-text-stroke-width': `${this.outlineWidth}${this.fontUnit}`,
      letterSpacing,
      ...(this.whiteSpace !== 'none' && { whiteSpace: this.whiteSpace })
    };
    for (let i = 0; i < Object.entries(styles).length; i++) {
      const [key, value] = Object.entries(styles)[i];
      if (value === null || value === undefined) {
        delete styles[key];
      }
    }
    return styles;
  }
}
